import { FEATURE_EXPERIMENT_JOB_LIST_A_A_BASIC } from 'src/App/config/features';

export interface Experiment {
  experimentNum: number;
  experimentId: string;
}

export const experiments = [
  {
    experimentId: FEATURE_EXPERIMENT_JOB_LIST_A_A_BASIC,
    experimentNum: 0,
  },
] satisfies Experiment[];
